import { createTheme } from "@mantine/core";
import type { MantineColorsTuple } from "@mantine/core";

// Color tokens derived from the SWEET OUTSIDE cover (see DESIGN_TOKENS.md).
// CSS variables live in src/styles/tokens.css.

const indigo: MantineColorsTuple = [
  "#eaeaff",
  "#cdcdfb",
  "#a8a8f6",
  "#8181f1",
  "#5e5fee",
  "#4a4bed",
  "#3f40ec",
  "#3535d3",
  "#2d2dbc",
  "#504ddc",
];

const magenta: MantineColorsTuple = [
  "#ffe5f1",
  "#ffb9d8",
  "#ff8cbf",
  "#ff5fa6",
  "#ff3aa0",
  "#e62687",
  "#b21b6a",
  "#7e144e",
  "#4a0c30",
  "#260418",
];

const cyan: MantineColorsTuple = [
  "#e6fbff",
  "#c0f3fb",
  "#94e8f6",
  "#65ddf1",
  "#3ed3ed",
  "#28cbeb",
  "#15c7eb",
  "#01b0d2",
  "#009dbc",
  "#0089a6",
];

export const theme = createTheme({
  primaryColor: "indigo",
  colors: { indigo, magenta, cyan },
  defaultRadius: "md",
  // Tektur applies to body text, buttons, and headings via Mantine theme
  // tokens. Inter is the immediate fallback for browsers that fail to load
  // Tektur, system fonts after that.
  fontFamily:
    "'Tektur', Inter, ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, sans-serif",
  headings: {
    fontFamily:
      "'Tektur', 'Space Grotesk', Inter, ui-sans-serif, system-ui, sans-serif",
    fontWeight: "700",
  },
  fontFamilyMonospace:
    "'JetBrains Mono', ui-monospace, SFMono-Regular, Menlo, Monaco, monospace",
});
